import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=2cf2078b&scoped=true"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"
import style0 from "./Rewards.vue?vue&type=style&index=0&id=2cf2078b&prod&lang=scss&scoped=true"
import style1 from "./Rewards.vue?vue&type=style&index=1&id=2cf2078b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2078b",
  null
  
)

export default component.exports